import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";

const PSSBannerMessage: React.FunctionComponent<{ layout: string; showAccessCodeField: boolean, setShowAccessCodeField:
    any }> = (props) => {
    const [closeButton, setCloseButton] = useState(true);
    const aflacFunction = () => {
        setCloseButton(false);
        setShowAccessCodeField(false);
    }
        let partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
            state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
                ? state.configurationState.configuration.partnerConfig.phoneNumber
                : ""
        );
        const phoneNumberlink = `tel:${partnerPhoneNumber}`;
    return (
        <React.Fragment>
            {props.layout === "psslandingaccesscode" && closeButton == true ? (
                <div className="row error-handling" style={{ display: "block" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li>
                                    Please verify that you have entered your access code correctly. If you need assistance, please contact us at
                                    <a href="tel:1-888-439-7443" style={{ color: "#376F95" }}> 1-888-439-7443</a> .
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : null}


            {props.layout === "retailerpsslandingaccesscode" && closeButton == true ? (
                <div className="row error-handling" style={{ display: "block" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li>
                                    Please verify that you have entered your access code correctly. If you need assistance, please contact us at
                                    <a style={{ color: "#376F95" }} href={phoneNumberlink}>{partnerPhoneNumber}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : null}

            {props.layout === "aflacpsslanding" && closeButton == true ? (
                <div className="row error-handling" style={{ display: "block" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => aflacFunction} className="las la-times" id="error-msg-close"></i>
                                <li>
                                    We’re sorry, the information you have entered is not valid or we could not find you in our system. If you need assistance, please contact us at
                                    <a href="tel:866-826-8851"> 866-826-8851</a> .
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : null}

            {props.layout === "psslandingerrormessage" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block", marginBottom: "40px" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                            <ul aria-required="true">Please correct the following validation error(s) in the form below</ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "psslandingcode" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li>
                                    We couldn’t find your information in our system.
                                    <ul style={{ listStyle: "disc" }}>
                                        <li>Please verify that you entered your name exactly as it appears on the statement from your financial institution.</li>
                                        <li>Be sure to allow 7 to 10 days for us to process your enrollment before using the look up below.</li>
                                    </ul>
                                    If you need assistance, please contact us at <a style={{ color: "#376F95" }} href="tel:1-888-439-7443">1-888-439-7443</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "retailerpsslandingerrormessage" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block", marginBottom: "40px" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                            <ul aria-required="true">Please correct the following validation error(s) in the form below</ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "retailerpsslandingcode" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li>
                                    We couldn’t find your information in our system.
                                    <ul style={{ listStyle: "disc" }}>
                                        <li>Please verify that you entered your name exactly as it appears on the statement from your financial institution.</li>
                                        <li>Be sure to allow 7 to 10 days for us to process your enrollment before using the look up below.</li>
                                    </ul>
                                    If you need assistance, please contact us at <a style={{ color: "#376F95" }} href={phoneNumberlink}>{partnerPhoneNumber}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "psslandingstartprotection" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block", zIndex: 1, marginTop: "-40px", marginBottom: "60px" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li aria-required="true">Currently there are no online pre-paid services associated with you.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "psslandingstartprotectionerrormsg" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block", marginTop: "-40px", marginBottom: "60px" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please correct the following validation error(s) in the form below
                                {/*<i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>*/}
                                <li aria-required="true">Please enter a valid code to continue</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "psslandingmaxattempterror" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block", marginTop: "-40px", marginBottom: "60px" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                For your information:
                                {/*<i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>*/}
                                <li aria-required="true">
                                    The maximum number of codes have already been redeemed. Please contact us at <a style={{ color: "#376F95" }} href={phoneNumberlink}>{partnerPhoneNumber}</a> for assistance.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "gsclanding" && closeButton === true && (
                <div className="row error-handling gsc-error" role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li aria-required="true">Currently there are no online pre-paid services associated with you.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "gsclandingerrormsg" && closeButton === true && (
                <div className="row error-handling gsc-error" role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please correct the following validation error(s) in the form below
                                {/*<i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>*/}
                                <li aria-required="true">Please enter a valid code to continue</li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "gscmaxattempterrormsg" && closeButton === true && (
                <div className="row error-handling gsc-error" role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                For your information:
                                <li aria-required="true">
                                    The maximum number of codes have already been redeemed. Please contact us at <a style={{ color: "#376F95" }} href={phoneNumberlink}>{partnerPhoneNumber}</a> for assistance.
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "pssfraudAdmor" && closeButton == true && (
                <div className="row error-handling" style={{zIndex:1}} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li aria-required="true">
                                    Please verify that you entered your information exactly as it appears on your check. Access to your online services may take
                                    7-10 days to process. If you need assistance, please contact us at <a href="tel:866-923-0452">866-923-0452</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "fraudarmorerrormessage" && closeButton == true && (
                <div className="row error-handling" style={{ display: "block",top:"5rem !important"}} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">Please correct the following validation error(s) in the form below</ul>
                        </div>
                    </div>
                </div>
            )}
            {props.layout === "psssisk" && closeButton == true ? (
                <div className="row pss-error-handling" style={{ display: "block" }} role="banner">
                    <div className="l-page-container">
                        <div role="alert" className="sys-msg-content">
                            <ul aria-required="true">
                                Please review the following error(s):
                                <i onClick={() => setCloseButton(false)} className="las la-times" id="error-msg-close"></i>
                                <li>
                                    Please verify that you have entered your member id correctly. If you need assistance, please contact us at
                                    <a href="tel:800-367-4600"> 800-367-4600.</a> .
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

export default PSSBannerMessage;

function setShowAccessCodeField(arg0: boolean) {
    throw new Error("Function not implemented.");
}
